import { makeEmptyCaption } from '@pm2/content-engine';
import { Video23Player } from '@pm2/media-component';
import { generateJsxKey, fallbackMediaSrc } from '@utils/ast';
import { jsx } from 'react/jsx-runtime';

const video23Parsers = {
  video23: node => {
    const data = JSON.parse(node.getAttribute("data")?.replaceAll(`'`, `"`) ?? "null");
    const photoId = data.photo_id;
    const token = data.token;
    const title = data.title;
    const description = data.description;
    const height = Number(data.original_height);
    const width = Number(data.original_width);
    const aspectRatio = Number.isNaN(height) || Number.isNaN(width) ? undefined : `${height / width * 100}%`;
    return {
      nodeType: "video23",
      photoId,
      title,
      token,
      description,
      aspectRatio
    };
  }
};
const video23Printers = {
  video23: (node, context) => {
    return /*#__PURE__*/jsx(Video23Player, {
      photoId: node.photoId,
      title: node.title,
      token: node.token,
      description: node.description,
      aspectRatio: node.aspectRatio,
      caption: makeEmptyCaption(),
      showSubtitlesByDefault: false
    }, generateJsxKey(context));
  }
};
const video23ToLatexPrinters = {
  video23: () => {
    return `\\includegraphics[width=\\textwidth]{${fallbackMediaSrc}}`;
  }
};

export { video23Parsers, video23Printers, video23ToLatexPrinters };
//# sourceMappingURL=spec.23video.js.map
